<template>
  <v-container>
    <v-form ref="form" v-model="valid" lazy-validation onSubmit="return false;">
      <v-card class="mx-auto" max-width="400">
        <v-card-title class="text-center justify-center">
          Для начала работы необходимо подтвердить свой e-mail
        </v-card-title>
        <v-card-text class="pt-5">
          <v-text-field
            label="E-mail"
            outlined
            v-model="email"
            :rules="[rules.required, rules.email]"
            required
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions class="justify-center pb-5">
          <div>
            <v-flex class="d-flex justify-center align-center pb-4">
              <v-checkbox v-model="checkbox"> </v-checkbox>
              <div>
                Я принимаю
                <a
                  href="https://www.avissign.com/policy/license/"
                  target="_blank"
                  >Пользовательское соглашение</a
                >
                и
                <a
                  href="https://www.avissign.com/policy/privacy"
                  target="_blank"
                  >Политику конфиденциальности</a
                >
                AvisSIGN.
              </div>
            </v-flex>
            <div class="text-center">
              <v-btn
                color="#009933"
                tile
                :dark="checkbox && valid"
                class="my-2"
                :disabled="!checkbox || !valid"
                @click="checkEmail()"
                >Подтвердить</v-btn
              >
            </div>
          </div>
        </v-card-actions>
        <v-overlay :value="overlay" absolute>
          <div class="text-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-overlay>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
  import api from '@/utils/axios'

  const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  export default {
    data() {
      return {
        checkbox: false,
        overlay: false,
        email: '',
        valid: false,
      }
    },

    computed: {
      rules() {
        return {
          required: (v) => !!v || 'Обязательное поле',
          email: (v) => patternEmail.test(v) || 'Неверный адрес E-mail',
        }
      },
    },

    mounted() {
      this.$refs.form.validate()
      parent.postMessage("avissign.appstart", "*")
    },

    methods: {
      async checkEmail() {
        this.overlay = true
        const newTransaction = {
          author: {
            source: 'Email',
            contact: this.email,
          },
        }
        await api.post('/transactions', newTransaction)
        this.overlay = false
        this.$router.push('/check')
      },
    },
  }
</script>
